import { MaterialLayoutRenderer } from "@jsonforms/material-renderers";
import React, { useMemo } from "react";
import { withJsonFormsLayoutProps } from "@jsonforms/react";
import { rankWith, uiTypeIs } from "@jsonforms/core";
import SFCard, { SFCardBody, SFCardHeader } from "../../card";
import SFTypography from "../../typography";
import getStyled from "../../../hooks/getStyled";
import { useTranslation } from "react-i18next";

const { styled } = getStyled();

const GroupRenderer = (props) => {
  const { uischema, schema, path, visible, renderers } = props;
  const { t } = useTranslation();

  const layoutProps = {
    elements: uischema.elements,
    label: uischema.i18nKey ? t(uischema.i18nKey) : uischema.label,
    schema: schema,
    path: path,
    visible: visible,
    uischema: uischema,
    renderers: renderers,
  };

  const StyledCard = useMemo(
    () =>
      styled(SFCard)(({ theme }) => ({
        height: "100%",
      })),
    []
  );

  const StyledCardHeader = useMemo(
    () =>
      styled(SFCardHeader)(({ theme }) => ({
        paddingBottom: 0,
      })),
    []
  );

  return (
    <StyledCard>
      <StyledCardHeader
        title={
          <SFTypography variant="h3" component="span">
            {layoutProps.label}
          </SFTypography>
        }
      />

      <SFCardBody>
        <MaterialLayoutRenderer {...layoutProps} />
      </SFCardBody>
    </StyledCard>
  );
};

export const GroupTester = rankWith(1000, uiTypeIs("Group"));

export default withJsonFormsLayoutProps(GroupRenderer);
